<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g transform="translate(1 3)">
      <path
        d="M16.139,5.25H2.806a.556.556,0,0,0-.556.556V7.472a.556.556,0,0,0,.556.556H16.139a.556.556,0,0,0,.556-.556V5.806A.556.556,0,0,0,16.139,5.25Z"
        transform="translate(-2.25 -5.25)"
        fill="none"
        stroke="#7b8190"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        :style="{ fill: 'none !important' }"
      />
      <path
        d="M15.972,9v6.667a.556.556,0,0,1-.556.556H4.306a.556.556,0,0,1-.556-.556V9"
        transform="translate(-2.639 -6.222)"
        fill="none"
        stroke="#7b8190"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        :style="{ fill: 'none !important' }"
      />
      <path
        d="M9.75,12.75h3.333"
        transform="translate(-4.194 -7.194)"
        fill="none"
        stroke="#7b8190"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        :style="{ fill: 'none !important' }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconBoxArchive',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>